export var EState;
(function (EState) {
    EState["loading"] = "loading";
    EState["loaded"] = "loaded";
    EState["error"] = "error";
})(EState || (EState = {}));
